// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/scrollspy.js
import BaseComponent from "./base_component"

export default class ScrollSpy extends BaseComponent {
  static componentName = "scrollspy"

  constructor(element, config = {}) {
    super(element, config)
    try {
      this.target =
        typeof this.config.target === "string" ? document.querySelector(this.config.target) : this.config.target
    } catch (_error) {
      this.target = null
    }
    this.activeLink = null
    this.listen(element, "scroll", () => this.refresh())
    this.refresh()
  }

  refresh() {
    if (!this.target) return

    const sectionById = new Map([...this.element.querySelectorAll("[id]")].map((section) => [section.id, section]))
    const sections = [...this.target.querySelectorAll('a[href^="#"]')]
      .map((link) => {
        if (!link.hash) return null

        let id
        try {
          id = decodeURI(link.hash.slice(1))
        } catch (_error) {
          return null
        }

        const section = sectionById.get(id)
        return section ? { link, section } : null
      })
      .filter(Boolean)

    if (!sections.length) return

    const top = this.element.scrollTop + Number(this.config.offset || 0) + 1
    let active = sections[0]
    this.target.querySelectorAll("a[href].active").forEach((link) => link.classList.remove("active"))
    sections.forEach((entry) => {
      const sectionTop =
        entry.section.getBoundingClientRect().top - this.element.getBoundingClientRect().top + this.element.scrollTop
      if (sectionTop <= top) active = entry
    })

    const scrolledToEnd = this.element.scrollTop + this.element.clientHeight >= this.element.scrollHeight - 1
    if (scrolledToEnd) active = sections.at(-1)

    active.link.classList.add("active")
    this.activateParents(active.link)

    if (this.activeLink !== active.link) {
      this.activeLink = active.link
      this.emit("activate", { relatedTarget: active.link })
    }
  }

  activateParents(link) {
    if (link.classList.contains("dropdown-item")) {
      link.closest(".dropdown")?.querySelector(".dropdown-toggle")?.classList.add("active")
      return
    }

    let navigation = link.closest(".nav, .list-group")
    while (navigation && this.target.contains(navigation)) {
      const previous = navigation.previousElementSibling
      if (previous?.matches(".nav-link, .list-group-item")) previous.classList.add("active")
      previous?.querySelector(":scope > .nav-link")?.classList.add("active")
      navigation = navigation.parentElement?.closest(".nav, .list-group")
    }
  }
}
